import React from 'react';
import './machine_css.css';
import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { pageVariants, pageTransition } from '../items/style/animationstyle';
import { ReactComponent as PlusSign } from '../Icons/Plus_sign.svg';
import { ReactComponent as MinusSign } from '../Icons/Minus_sign.svg';
import { ReactComponent as BackIcon } from '../Icons/Back_icon.svg';
import { ReactComponent as CartIcon } from '../Icons/Cart_icon.svg';
import { ReactComponent as HomeIcon } from '../Icons/Home_icon.svg';
import { ReactComponent as GiftIcon } from '../Icons/gift.svg';
import { PlayCircleOutline } from '@material-ui/icons';
import { Link, useHistory } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { HighlightOffRounded } from '@material-ui/icons';
import { cartAnimation } from './items/animation';
import PlanModal from './PlanModal';
import logger from '../services/LocalServer/logger';
import { currencyStyle } from '../services/methods';
import { currencyOptions } from '../staticData/options';
import Cookies from 'js-cookie';
import { ExitToApp } from '@material-ui/icons';
import BottomCart from './ShoppingCart/BottomCart';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

export default function ProductDescription(props) {
  const homepage = localStorage.getItem('homepage');
  const isLocal = localStorage.getItem('ISLOCAL') === 'TRUE';
  const {
    products,
    decreStock,
    langs,
    MAXCARTNUM,
    add,
    itemCounter,
    remove,
    stat,
    setStat,
    machineID,
    setShowCart,
    showCart,
    cart,
    alterquantity,
  } = props;
  let symbol = JSON.parse(localStorage.getItem('machine'))?.currency?.symbol;
  let logoutIcon = localStorage.getItem('LOGOUT') === 'TRUE';
  const msc = localStorage.getItem('MSC') === 'TRUE';

  symbol = symbol ? symbol : '$';
  const idx = props.i;
  const { t } = useTranslation();
  const [quantity, setQuantity] = useState(0);
  const [promoQtt, setPromoQtt] = useState(0);
  const [index, setIndex] = useState(0);
  const [show, setShow] = useState(false);
  const [showp, setShowp] = useState(false);
  const history = useHistory();
  // const today = new Date();
  const [mainL, setMainL] = useState('en-US');

  const Fname =
    products[idx].name[langs] && products[idx].name[langs] !== ''
      ? products[idx].name[langs]
      : products[idx].name?.en;

  const FDetail =
    products[idx].detail && products[idx].detail[langs] && products[idx].detail[langs] !== ''
      ? products[idx].detail[langs]
      : products[idx].detail?.en;

  const FDesc =
    products[idx].description &&
    products[idx].description[langs] &&
    products[idx].description[langs] !== ''
      ? products[idx].description[langs]
      : products[idx].description?.en;

  const FTitle1 =
    products[idx].title1 && products[idx].title1[langs] && products[idx].title1[langs] !== ''
      ? products[idx].title1[langs]
      : products[idx].title1?.en;

  const FTitle2 =
    products[idx].title2 && products[idx].title2[langs] && products[idx].title2[langs] !== ''
      ? products[idx].title2[langs]
      : products[idx].title2?.en;

  const FSpec =
    products[idx].ingredients &&
    products[idx].ingredients[langs] &&
    products[idx].ingredients[langs] !== ''
      ? products[idx].ingredients[langs]
      : products[idx].ingredients?.en;

  const FInclude =
    products[idx].allergens &&
    products[idx].allergens[langs] &&
    products[idx].allergens[langs] !== ''
      ? products[idx].allergens[langs]
      : products[idx].allergens?.en;

  useEffect(() => {
    const mycoockie = Cookies.get('i18next');
    if (mycoockie === 'fr') {
      setMainL('fr-CA');
    } else if (mycoockie === 'es') {
      setMainL('es-US');
    }
    //stat
  }, []);

  useEffect(() => {
    const index = stat?.prod.findIndex((item) => item._id === products[idx]._id);
    if (index >= 0) {
      stat.prod[index].detail = stat.prod[index].detail += 1;
    } else {
      stat.prod.push({
        _id: products[idx]._id,
        name: products[idx].name?.en,
        detail: 1,
        add_to_cart: 0,
        conv: 0,
      });
    }
    setStat(stat);
  }, []);

  useEffect(() => {
    if (props.cart.length > 0) {
      const index = props.cart?.findIndex((item) => item.id === products[idx]._id);
      if (index >= 0) {
        setQuantity(props.cart[index].quantity);
        setPromoQtt(props.cart[index].promoQtt);
      } else {
        setQuantity(0);
      }
    } else {
      setQuantity(0);
    }
    return () => {};
  }, [props.cart]);

  const addToCart = (e) => {
    const index = props.cart?.findIndex((item) => item.id === products[idx]._id);
    // if (
    //   products[idx].plan &&
    //   Date.parse(products[idx].plan.start) <= today &&
    //   Date.parse(products[idx].plan.end) >= today
    // ) {
    //   setShowp(true);
    // }
    if (index >= 0) {
      props.alterquantity({ id: products[idx]._id }, props.cart[index].quantity + 1);
    } else {
      props.add({
        idx: parseInt(idx),
        id: products[idx]._id,
        key: products[idx]._id,
        _id: products[idx]._id,
        upc: products[idx]?.upc,
        name: products[idx].name,
        title: products[idx].name,
        promo: products[idx].promo,
        price: products[idx].price,
        discount: products[idx].discount ? products[idx].discount : 0,
        percentage: products[idx].percentage,
        discountedPrice: products[idx].discountedPrice
          ? products[idx].discountedPrice
          : products[idx].price,
        image: products[idx].productPictures[0],
        buyX: products[idx].buyX ? products[idx].buyX : 0,
        quantity: 1,
        category: products[idx].category,
        ingredients: products[idx].ingredients,
        referTo: products[idx].referTo,
        prodType: products[idx].prodType,
        current_stock: products[idx].current_stock,
        emailCode: products[idx].emailCode,
        promoIndex: products[idx].promoIndex,
        nextPurchase: products[idx].nextPurchase,
        tax_type: products[idx].tax_type,
      });
    }
  };

  const calculateProductPrice = () => {
    const index = props.cart.findIndex((e) => e._id === products[idx]._id);
    const originPrice = (
      <del>
        {currencyStyle(
          langs,
          symbol,
          parseFloat((products[idx].price * quantity).toFixed(2))
        ).toLocaleString(mainL, currencyOptions)}
      </del>
    );
    if (quantity === 0) {
      return `$0`;
    } else {
      if (products[idx]?.buyX > 1) {
        if (promoQtt === 1) {
          return `$${products[idx].price}`;
        } else if (promoQtt > 1) {
          if (promoQtt % products[idx].buyX === 0) {
            if (products[idx].percentage == true) {
              return (
                <span>
                  {originPrice}
                  <span style={{ color: 'red', marginLeft: '0.5em' }}>
                    {currencyStyle(
                      langs,
                      symbol,
                      parseFloat(
                        (products[idx].discountedPrice * quantity).toFixed(2)
                      ).toLocaleString(mainL, currencyOptions)
                    )}
                  </span>
                </span>
              );
            } else {
              return (
                <span>
                  {originPrice}
                  <span style={{ color: 'red', marginLeft: '0.5em' }}>
                    {currencyStyle(
                      langs,
                      symbol,
                      parseFloat(
                        (
                          products[idx].price * quantity -
                          parseFloat(
                            ((quantity * products[idx].discount) / products[idx].buyX).toFixed(2)
                          )
                        ).toFixed(2)
                      ).toLocaleString(mainL, currencyOptions)
                    )}
                  </span>
                </span>
              );
            }
          } else {
            if (promoQtt < products[idx].buyX) {
              return currencyStyle(
                langs,
                symbol,
                parseFloat((products[idx].price * quantity).toFixed(2)).toLocaleString(
                  mainL,
                  currencyOptions
                )
              );
            } else {
              if (products[idx].percentage == true) {
                return (
                  <span>
                    {originPrice}
                    <span style={{ color: 'red', marginLeft: '0.5em' }}>
                      {currencyStyle(
                        langs,
                        symbol,
                        parseFloat(
                          (products[idx].discountedPrice * quantity).toFixed(2)
                        ).toLocaleString(mainL, currencyOptions)
                      )}
                    </span>
                  </span>
                );
              } else {
                console.log(products[idx]);
                return (
                  <span>
                    {originPrice}
                    <span style={{ color: 'red', marginLeft: '0.5em' }}>
                      {currencyStyle(
                        langs,
                        symbol,
                        parseFloat(
                          (
                            quantity * products[idx].price -
                            (quantity * products[idx].discount) / props.cart[index].promoQtt
                          ).toFixed(2)
                        )
                      ).toLocaleString(mainL, currencyOptions)}
                    </span>
                  </span>
                );
              }
            }
          }
        } else return currencyStyle(langs, symbol, 0);
      } else {
        if (products[idx].discount > 0 && quantity > 0) {
          return (
            <span>
              {originPrice}
              <span style={{ color: 'red', marginLeft: '0.5em' }}>
                {currencyStyle(
                  langs,
                  symbol,
                  parseFloat((products[idx].discountedPrice * quantity).toFixed(2)).toLocaleString(
                    mainL,
                    currencyOptions
                  )
                )}
              </span>
            </span>
          );
        } else if (products[idx].discount > 0 && quantity == 0) return `$0`;
        else
          return currencyStyle(
            langs,
            symbol,
            parseFloat((products[idx].price * quantity).toFixed(2)).toLocaleString(
              mainL,
              currencyOptions
            )
          );
      }
    }
  };

  if (!products[idx]?.productPictures) {
    return (
      <div className="row justify-content-center m-auto">
        <span className="cat-title">{t('Loading')}...</span>
      </div>
    );
  } else {
    const pictures = products[idx].productPictures.map((picture, i) => {
      return (
        <div
          key={i}
          className={`d-flex flex-column justify-content-center align-items-center  ${
            index === i ? 'product-image-active' : ''
          }`}
          style={{
            height: '120px',
            width: '120px',
            backgroundColor: 'white',
            marginLeft: '1em',
            marginRight: '1em',
          }}
        >
          {products[idx].current_stock == 0 && <div className="crossLine"></div>}
          <img
            onClick={() => {
              if (index !== i) {
                setIndex(i);
              }
            }}
            style={{
              maxHeight: '90%',
              maxWidth: '90%',
            }}
            key={picture}
            src={
              isLocal
                ? `${process.env.REACT_APP_LOCAL_API}/pictures/products/${picture}`
                : `${process.env.REACT_APP_SERVER_API}/pictures/${picture}/${products[idx].referTo}`
            }
            alt="picture"
          />
        </div>
      );
    });

    const getPrice = () => {
      if (products[idx].discountedPrice && products[idx].buyX > 1) return products[idx].price;
      else if (products[idx].discountedPrice) return products[idx].discountedPrice;
      else return products[idx].price;
    };

    function imageSlider(e) {
      if (e == 'small') {
        if (index === products[idx].productPictures.length) {
          return (
            <video
              className="p-4 media-animation"
              onClick={() => setShow(true)}
              src={
                isLocal
                  ? `${process.env.REACT_APP_LOCAL_API}/pictures/products/${products[idx].productVideo}`
                  : `${process.env.REACT_APP_SERVER_API}/pictures/${products[idx].productPictures[index]}/${products[idx].referTo}`
              }
              autoPlay
            ></video>
          );
        } else
          return (
            <img
              key={index}
              src={
                isLocal
                  ? `${process.env.REACT_APP_LOCAL_API}/pictures/products/${products[idx].productPictures[index]}`
                  : `${process.env.REACT_APP_SERVER_API}/pictures/${products[idx].productPictures[index]}/${products[idx].referTo}`
              }
              onClick={() => setShow(true)}
              alt="product-image"
              className="p-4 media-animation"
            />
          );
      } else {
        if (index === products[idx].productPictures.length) {
          return (
            <video
              className="p-4 big-media-animation"
              src={
                isLocal
                  ? `${process.env.REACT_APP_LOCAL_API}/pictures/products/${products[idx].productVideo}`
                  : `${process.env.REACT_APP_SERVER_API}/videos/${products[idx].productVideo}/${products[idx].referTo}`
              }
              autoPlay
            ></video>
          );
        } else
          return (
            <img
              key={index}
              src={
                isLocal
                  ? `${process.env.REACT_APP_LOCAL_API}/pictures/products/${products[idx].productPictures[index]}`
                  : `${process.env.REACT_APP_SERVER_API}/pictures/${products[idx].productPictures[index]}/${products[idx].referTo}`
              }
              alt="product-image"
              className="p-4 big-media-animation"
            />
          );
      }
    }

    return (
      <div className="ui-secondary-div ui-secondary-div-desc">
        <motion.div
          key="product-div"
          className="container"
          initial="initial"
          exit="out"
          animate="in"
          variants={pageVariants}
          transition={pageTransition}
        >
          <div className="row justify-content-center pt-5 mb-4">
            <span className="cat-title descFontB">{t('Product').toUpperCase()}</span>
          </div>
          <div className="d-flex justify-content-center">
            <div
              className="col-md-11 mb-5 category-card"
              style={{
                boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)',
              }}
            >
              <div>
                <div
                  style={{
                    display: 'flex',
                    border: 'none',
                    borderRadius: '1em',
                    borderBottom: 'none',
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0,
                    paddingTop: '1rem',
                    height: '500px',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  {imageSlider('small')}
                </div>
                {products[idx].current_stock == 0 && (
                  <div>
                    <div className="category-card out_of_stock_div1"></div>
                    <div className="out_of_stock_text1 d-flex flex-column justify-content-center align-items-center">
                      <p style={{ marginBottom: '-10px' }}>Out of</p>
                      <p>Stock</p>
                      {/* <p style={{ marginBottom:'-10px'}}>{t('Out of')}</p>
                                <p >{t('Stock')}</p> */}
                    </div>
                  </div>
                )}
              </div>
              <div
                className="d-flex"
                style={{
                  flexDirection: 'column',
                  justifyContent: 'left',
                  textAlign: 'left',
                  alignItems: 'center',
                  padding: '24px',
                  paddingTop: 0,
                }}
              >
                <h5
                  className="card-category-title descFontB"
                  style={{
                    width: '100%',
                    fontSize: '47px',
                    color: 'inherit',
                    marginBottom: 0,
                  }}
                >
                  {Fname}
                </h5>
                {FDetail && (
                  <div
                    className="card-category-title descFont"
                    style={{
                      width: '100%',
                      fontSize: '30px',
                      color: 'inherit',
                      marginBottom: 0,
                    }}
                  >
                    {FDetail}
                  </div>
                )}
                <div
                  style={{
                    marginTop: '10px',
                    marginBottom: '10px',
                    marginLeft: '-540px',
                  }}
                >
                  <div className="product-description-price descFontB">
                    {currencyStyle(
                      langs,
                      symbol,
                      getPrice().toLocaleString(mainL, currencyOptions)
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-center">
            {pictures}
            {products[idx].productVideo && (
              <div>
                {products[idx].current_stock == 0 && <div className="crossLine2"></div>}
                <div
                  className={`d-flex justify-content-center align-content-center align-items-center  ${
                    index === products[idx].productPictures.length && 'product-image-active'
                  }`}
                  onClick={() => setIndex(products[idx].productPictures.length)}
                  style={{
                    height: '120px',
                    width: '120px',
                    marginLeft: '1em',
                    marginRight: '1em',
                    backgroundColor: 'lightgrey',
                  }}
                >
                  <PlayCircleOutline className="play_icon_div" style={{ fontSize: '80px' }} />
                </div>
              </div>
            )}
          </div>
          <div className="desc-text-container">
            <div>
              <h2 className="product-description-title">{t(`Description`)}</h2>
            </div>
            <div>
              <p className="product-description-info">{FDesc}</p>
            </div>
            {FTitle1 && FSpec !== '' && (
              <div>
                <div>
                  <h2 className="product-description-title">{FTitle1}</h2>
                </div>
                <div>
                  <p className="product-description-info">{FSpec}</p>
                </div>
              </div>
            )}
            {FTitle2 && FInclude !== '' && (
              <div>
                <div>
                  <h2 className="product-description-title">{FTitle2}</h2>
                </div>
                <div>
                  <p className="product-description-info">{FInclude}</p>
                </div>
              </div>
            )}
          </div>

          <HighlightOffRounded
            style={{ fontSize: '60px' }}
            className="desc_close_circle_icon"
            onClick={() => history.push(`/machineUI/category/all/All Products/${props.machineID}`)}
          />
          <Modal
            className="animate__animated animate__zoomInDownz animate__zoomInz"
            id="desc-modal"
            show={show}
            onHide={() => setShow(false)}
            size="xl"
            centered
          >
            {imageSlider()}
          </Modal>
        </motion.div>
        <GiftIcon className="svg-style giftsvg" />
        <div className="bottom-buttons-div bottom-buttons-div-desc">
          <div className="d-flex column product-control-panel">
            <div
              className="d-flex"
              style={{
                justifyContent: 'space-between',
              }}
            >
              <div className="d-flex align-items-center">
                {quantity > 0 && (
                  <>
                    <MinusSign
                      height={50}
                      className="svg-style-color"
                      onClick={() => {
                        cartAnimation();
                        decreStock(products[idx], products[idx].current_stock + 1);
                        if (quantity === 1) {
                          props.remove({ id: products[idx]._id });
                        } else if (quantity > 1) {
                          const index = props.cart?.findIndex(
                            (item) => item.id === products[idx]._id
                          );
                          props.alterquantity(
                            { id: products[idx]._id },
                            props.cart[index].quantity - 1
                          );
                        }
                      }}
                    />
                    <h2 className="ml-3 mr-3 product-item-counter">{quantity}</h2>
                    {products[idx].current_stock > 0 && itemCounter < MAXCARTNUM && (
                      <PlusSign
                        height={50}
                        className="svg-style-color"
                        onClick={() => {
                          if (products[idx].current_stock > 0) {
                            decreStock(products[idx], products[idx].current_stock - 1);
                            addToCart();
                            cartAnimation(true);
                          }
                        }}
                      />
                    )}
                  </>
                )}
              </div>

              <div className="product-total-price">
                {t(`Total`)}: {calculateProductPrice()}
              </div>
            </div>
            <div
              className="d-flex mt-3"
              style={{
                justifyContent: 'space-around',
              }}
            >
              {products[idx].current_stock > 0 && itemCounter < MAXCARTNUM && (
                <div
                  onClick={() => {
                    if (products[idx].current_stock > 0) {
                      cartAnimation(true);
                      decreStock(products[idx], products[idx].current_stock - 1);
                    }
                    addToCart();
                  }}
                  className={
                    msc
                      ? `product-description-price blink_me descFontB`
                      : `product-description-price descFontB`
                  }
                  style={{
                    width: '400px',
                    cursor: 'pointer',
                  }}
                >
                  {t(`Add to Cart`)}
                </div>
              )}
            </div>
          </div>

          <div className="descBottomNav">
            <Link to={homepage}>
              <HomeIcon className="svg-style svg-style-desc mr-3" />
            </Link>
            <CartIcon
              className="svg-style svg-style-desc myCartIcon"
              onClick={() => {
                if (localStorage.getItem('cartStyle') === 'true') {
                  setShowCart(true);
                } else {
                  history.push(`/machineUI/${props.machineID}/checkout`);
                }
              }}
            />
            <span className="item-counter-p">
              <span className="myCartCounter">{props.itemCounter}</span>
            </span>
            <BackIcon
              className="svg-style svg-style-desc ml-3"
              onClick={() =>
                history.push(`/machineUI/category/all/All Products/${props.machineID}`)
              }
            />
            {logoutIcon && (
              <Link to={`/machineUI/slider/${machineID}`}>
                <ExitToApp className="svg-style svg-style-desc myCartIcon" />
              </Link>
            )}
          </div>
        </div>
        <PlanModal
          cart={props.cart}
          alterquantity={props.alterquantity}
          add={props.add}
          show={showp}
          prod={products[idx]}
          onHide={() => {
            setShowp(false);
          }}
        />
        <BottomCart
          isLocal={isLocal}
          cart={cart}
          setShowCart={setShowCart}
          showCart={showCart}
          langs={langs}
          add={add}
          decreStock={decreStock}
          alterquantity={alterquantity}
          remove={remove}
        />
      </div>
    );
  }
}
